export default __webpack_public_path__ + "media/mindful-reversed-RGB.a692f6da.svg";